import styles from './styles.scss';
import { AutoCompleteSuggestion } from 'models/AutoCompleteSuggestion';
import AutoCompleteProduct from './autoCompleteProduct';
import AutoCompleteCategory from './autoCompleteCategory';
import AutoCompleteBrandCategory from './autoCompleteBrandCategory';
import AutoCompleteDidYouMean from './autoCompleteDidyouMean';
import cn from 'classnames';

interface OwnProps {
  searchSuggestions: AutoCompleteSuggestion;
  searchUrl: string;
  onSelect: () => void;
  txtNoHits: string;
  txtDidYouMean: string;
  txtBrand: string;
  txtCategories: string;
  txtProducts: string;
}

const maxCategoryCount = 3;

// export default ({
//   searchSuggestions,
//   searchUrl,
//   onSelect
// }: OwnProps) => {
export default (props: OwnProps) => {
  const {
    searchSuggestions,
    searchUrl,
    onSelect,
    txtNoHits,
    txtDidYouMean,
    txtBrand,
    txtCategories,
    txtProducts
  } = props;

  let wrapperClass = styles.autoComplete;
  let halfClass = styles.half;

  if (
    (searchSuggestions.suggestedBrandCategories.length === 0 &&
      searchSuggestions.suggestedCategories.length === 0) ||
    searchSuggestions.suggestedProducts.length === 0
  ) {
    wrapperClass += ' ' + styles.singlecolumn;
    halfClass += ' ' + styles.singlecolumn;
  }

  return (
    <div className={wrapperClass}>
      {searchSuggestions.suggestedProducts.length === 0 &&
        searchSuggestions.suggestedBrandCategories.length === 0 &&
        searchSuggestions.suggestedCategories.length === 0 && (
          <AutoCompleteDidYouMean
            searchString={searchSuggestions.searchString}
            suggestions={searchSuggestions.suggestedDidYouMean}
            searchUrl={searchUrl}
            txtNoHits={txtNoHits}
            txtDidYouMean={txtDidYouMean}
          />
        )}
      {(searchSuggestions.suggestedBrandCategories.length > 0 ||
        searchSuggestions.suggestedCategories.length > 0) && (
        <div className={cn(halfClass, styles.categories)}>
          {searchSuggestions.suggestedBrandCategories.length > 0 && (
            <div className={styles.brandHolder}>
              <p className={styles.typeHeader}>{txtBrand}</p>
              {searchSuggestions.suggestedBrandCategories.map((category, index) => {
                const selected =
                  searchSuggestions.selectedItemIndex > -1 &&
                  searchSuggestions.selectedItemIndex < 3 &&
                  searchSuggestions.selectedColumnIndex === 1;

                if (index > 1) {
                  return undefined;
                }
                return (
                  <AutoCompleteBrandCategory
                    key={index}
                    categoryData={category}
                    selected={selected}
                    onSelect={onSelect}
                    txtProducts={txtProducts}
                  />
                );
              })}
            </div>
          )}
          {searchSuggestions.suggestedCategories.length > 0 && (
            <div>
              <p className={styles.typeHeader}>{txtCategories}</p>
              {searchSuggestions.suggestedCategories.map((category, index) => {
                let selected = false;
                if (searchSuggestions.suggestedBrandCategories.length > 0) {
                  if (
                    searchSuggestions.selectedItemIndex > 2 &&
                    searchSuggestions.selectedColumnIndex === 1
                  ) {
                    selected = true;
                  }
                } else {
                  selected =
                    searchSuggestions.selectedColumnIndex === 1 &&
                    searchSuggestions.selectedItemIndex === index;
                }

                if (
                  (searchSuggestions.suggestedBrandCategories.length > 0 && index > 0) ||
                  index > maxCategoryCount
                ) {
                  return undefined;
                }
                return (
                  <AutoCompleteCategory
                    key={index}
                    categoryData={category}
                    selected={selected}
                    onSelect={onSelect}
                    txtProducts={txtProducts}
                  />
                );
              })}
            </div>
          )}
        </div>
      )}
      {searchSuggestions.suggestedProducts.length > 0 && (
        <div className={cn(halfClass, styles.products)}>
          <div>
            <p className={styles.typeHeader}>{txtProducts}</p>
            {searchSuggestions.suggestedProducts.map((product, index) => {
              const selected =
                searchSuggestions.selectedColumnIndex === 0 &&
                searchSuggestions.selectedItemIndex === index;

              return (
                <AutoCompleteProduct
                  key={index}
                  selected={selected}
                  productData={product}
                  onSelect={onSelect}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
